/* globals rxSwitchboard */
var jQuery = require('jquery');
var _ = require('lodash');

;(function(){
  var jui_events = rxSwitchboard.subjects.jui_events,
    msgClass = 'lp-parenting-msg',
    msgParentClass = msgClass+'-container',
    dragStartParent = null,
    msgFontSizePx = 14;

  var log = function(/* msg */) {
    // console.log(msg);
  };
  var messageDiv = function() {
    return jQuery('<div class="'+msgClass+'"></div>')
      .html('Move + hold &#8984; or \'ctrl\' to ensure moving this element does not affect your desktop page ');
  };
  var reset = function () {
    jQuery('.'+msgClass).remove();
    jQuery('.'+msgParentClass).removeClass(msgParentClass);
  };

  var addIndicatorForReparentedElement = function(el) {
    if (window.editor.page.isMobileBreakpoint()) {
      reset();
      if (el.containerId === dragStartParent.id) {
        // don't display the message if we're moving back into our orig parent
        return;
      }
      // the dnd / reparenting creates an identical clone of the original which gets layered
      // above the orig. We need to add the msg to the clone, which is the visible one.
      var $elems = jQuery('[id="'+ el.id +'"]');
      var $el = (($elems.length === 2) ?
                 jQuery($elems[1])
                 : $elems);


      if ( ! $el.hasClass('lp-protruding')) {
        var $msgDiv = messageDiv();
        if (el.type === 'lp-pom-text') {
          // the msg needs scaling on text elements that have been css transform scaled.
          var scale = el.model.getScale();
            if (scale !== 1) {
              var fontSize = (msgFontSizePx/scale).toFixed(2) + 'px !important';
              $msgDiv.css('cssText', 'font-size: ' + fontSize);
            }
          }
        $el.append($msgDiv).addClass(msgParentClass);
      }
    }
  };

  var watchElements = function() {
    // other start/stopMove events are fired by other
    // elements, so remove the ones we don't care about.
    var transformBoxEvents = jui_events
       .filter(function (e) {return ! _.isUndefined(e.data);});

    transformBoxEvents.filter(function(e){
      return e.type === 'parentChanged';
    })
      .delay(20)
      .map(function (ev) { return ev.data;})
      .subscribe(function(el){
        try {
          addIndicatorForReparentedElement(el);
        } catch (e) {
          log(e);
        }
      });

    // we need to keep a reference to the starting container when
    // dragging / reparenting elements
    transformBoxEvents.filter(function (e) {return e.type === 'startMove';})
      .subscribe(function(e) {
        dragStartParent = e.data.getParentElement();
      });
    transformBoxEvents.filter(function (e) {return e.type === 'stopMove';})
      .subscribe(function() {
        dragStartParent = null;
      });


    transformBoxEvents.filter(function (e) {
      return e.type === 'stopMove' ||
        e.type === 'elementDragStop' ||
        e.type === 'mouseout';
    })
    .delay(25)
    .subscribe(function() {
      try {
        reset();
        // this throws sometimes:
        window.editor.transformBox.elementModelChanged();
      } catch (e) {
        log(e);
      }
    });
  };

  watchElements();
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/element_reparenting_tooltip.js
// module id = 1048
// module chunks = 0